import { BasicStorageManager } from '@bridebook/toolbox/src/storage-managers';

export const InitialisedGuestListStorage = BasicStorageManager<boolean>({
  storageKey: 'initialised-guest-list',
});
